{
    "Accessibility Menu": "アクセシビリティメニュー",
    "Reset settings": "設定をリセット",
    "Close": "閉じる",
    "Content Adjustments": "コンテンツ調整",
    "Adjust Font Size": "フォントサイズを調整",
    "Highlight Title": "タイトルを強調表示",
    "Highlight Links": "リンクを強調表示",
    "Readable Font": "読みやすいフォント",
    "Color Adjustments": "色の調整",
    "Dark Contrast": "ダークコントラスト",
    "Light Contrast": "ライトコントラスト",
    "High Contrast": "高いコントラスト",
    "High Saturation": "彩度が高い",
    "Low Saturation": "彩度が低い",
    "Monochrome": "モノクローム",
    "Tools": "ツール",
    "Reading Guide": "読み上げガイド",
    "Stop Animations": "アニメーションを停止",
    "Big Cursor": "大きなカーソル",
    "Increase Font Size": "フォントサイズを大きくする",
    "Decrease Font Size": "フォントサイズを小さくする",
    "Letter Spacing": "文字間隔",
    "Line Height": "行の高さ",
    "Font Weight": "フォントの太さ",
    "Dyslexia Font": "ディスレクシア用フォント",
    "Language": "言語",
    "Open Accessibility Menu": "アクセシビリティメニューを開く"
}